<template>
    <performance-common-dialog
        :title="'整单装车页面'"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'350px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-width="100px"
                :model="form"
                :rules="rules"
            >
                <el-form-item label="装车时间：" prop="loadDate">
                    <el-date-picker
                        v-model="form.loadDate"
                        type="datetime"
                        :value-format="'yyyy-MM-dd HH:mm:ss'"
                        placeholder="请选择时间"
                    />
                </el-form-item>
                <div class="footer-bottom">
                    <el-button
                        type="primary"
                        :loading="loading"
                        @click="srueBillPrint"
                    >
                        整单装车
                    </el-button>
                </div>
            </el-form>
        </template>
    </performance-common-dialog>
</template>
<script>
import dayjs from 'dayjs';
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import { saveDispatchLoadInfo } from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';

export default {
    name: 'dispatchArrivalRegistration',
    components: { PerformanceCommonDialog },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false,
            form: {
                loadDate: dayjs().format('YYYY-MM-DD HH:mm:ss')
            },
            rules: {
                loadDate: [
                    {
                        required: true,
                        message: '请选择装车时间时间',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        /**
         * @description 整单装车
        */
        async srueBillPrint () {
            const { validate } = this.$refs.formRef;
            await validate();
            const param = {
                dispatchNo: this.componentsData.dispatchNo,
                loadDate: this.form.loadDate
            };
            this.loading = true;
            saveDispatchLoadInfo(param).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.msg || '操作成功');
                    this.dialogClose();
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        dialogClose () {
            this.$emit('components-close');
        }
    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
    }

};
</script>

<style scoped lang="less">
.footer-bottom {
    display: flex;
    justify-content: flex-end;
    margin: 10px 0;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
</style>
